var _class;
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Box, Button, Card, Collapse, ColorBlock, Flex, Icon, Tag, Text } from 'core/components';
let SelectedValueButton = observer(_class = class SelectedValueButton extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isOpen: false
    };
    this.handleToggleOpen = e => {
      e.stopPropagation();
      this.setState(prevState => ({
        isOpen: !prevState.isOpen
      }));
    };
    this.handleRemove = () => {
      const {
        onRemove,
        option,
        field
      } = this.props;
      onRemove?.(option, field);
    };
  }
  render() {
    const {
      option,
      style,
      onRemove,
      className,
      disabled,
      label: propLabel,
      icon: propIcon
    } = this.props;
    const {
      isOpen
    } = this.state;
    const {
      label: optionLabel,
      activeDevices = [],
      color,
      iconName: optionIcon
    } = option || {};
    const iconName = propIcon || optionIcon;
    const label = propLabel || optionLabel;
    const hasDevices = !!(typeof activeDevices === 'number' ? activeDevices : activeDevices?.length);
    const removeButton = onRemove && /*#__PURE__*/React.createElement(Button, {
      className: className,
      onClick: this.handleRemove,
      icon: "cross",
      disabled: disabled,
      small: true,
      minimal: true
    });
    const activeDeviceCount = typeof activeDevices === 'number' ? activeDevices : activeDevices?.length;
    return /*#__PURE__*/React.createElement(Card, {
      mb: 1,
      style: style
    }, /*#__PURE__*/React.createElement(Flex, {
      p: "4px",
      justifyContent: "space-between",
      fontSize: "small",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center",
      flex: 1,
      pl: "4px"
    }, /*#__PURE__*/React.createElement(Box, {
      mr: "6px"
    }, color && /*#__PURE__*/React.createElement(ColorBlock, {
      color: color,
      style: {
        width: 14,
        height: 14,
        minHeight: 14
      }
    }), !color && /*#__PURE__*/React.createElement(Icon, {
      icon: iconName,
      color: "muted",
      iconSize: 14
    })), label), hasDevices && (Array.isArray(activeDevices) ? /*#__PURE__*/React.createElement(Button, {
      icon: isOpen ? 'caret-down' : 'caret-right',
      onClick: this.handleToggleOpen,
      className: className,
      text: `${activeDeviceCount} devices`,
      disabled: disabled,
      small: true,
      minimal: true
    }) :
    /*#__PURE__*/
    /**
     * TODO CORE-1213: Once we have a simple API for fetching the devices belonging to a given site we could use it here to restore the button
     */
    React.createElement(Text, null, activeDeviceCount, " devices")), removeButton), Array.isArray(activeDevices) && /*#__PURE__*/React.createElement(Collapse, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(Box, {
      style: {
        padding: '0 8px 4px'
      }
    }, activeDevices.map(device => /*#__PURE__*/React.createElement(Tag, {
      key: device.id,
      mr: "4px",
      mb: "4px"
    }, device.device_name)))));
  }
}) || _class;
export default SelectedValueButton;